// extracted by mini-css-extract-plugin
export default {"layout":"index_layout__lyBLP","right":"index_right__MP-AX","title":"index_title__0BRLz","picture":"index_picture__Ls1GQ"};